export default __webpack_public_path__ + "static/media/ghostly-img.ae21d1c9.png";